import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { HTMLAttributes } from 'react';

export type BrokerListItemProps = {
  props: HTMLAttributes<HTMLLIElement>;
  option: {
    value: string;
    email: string;
    label: string;
  };
};

export const BrokerListItem = ({ option, props }: BrokerListItemProps) => {
  return (
    <Box
      component='li'
      {...props}
      key={option.value}
      sx={{
        backgroundColor: 'white',
      }}
    >
      <Typography
        variant='bodySmall'
        sx={{
          color: 'common.black',
        }}
      >
        {option.label}
        <Typography
          sx={{
            wordBreak: 'break-all',
          }}
          variant='caption'
          fontWeight='normal'
          display='block'
          color='text.subdued'
        >
          {option.email}
        </Typography>
      </Typography>
    </Box>
  );
};
